/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkDifficultyHistoryItem } from './network-difficulty-history-item';
import { NetworkDifficultyExpectedChange } from './network-difficulty-expected-change';


export interface NetworkDifficultyHistoryResponse { 
    difficultyHistoryItems?: Array<NetworkDifficultyHistoryItem> | null;
    expectedChange?: NetworkDifficultyExpectedChange;
}

